/* eslint-disable react/no-multi-comp */

import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import ErrorBoundary from '../error-boundary'
import ErrorFeature from '../error-feature'
import { RavenContext } from '../../context'

// The default error to show. Overwrite this with ErrorPage if the erroring
// component sits outside of a header/footer ie outside a centre.
const Feature = ({ error, info }) => (
  <ErrorFeature status={404} error={error.message} />
)

// Protect a route with an error boundary. This exists here specifically so
// that it can protect against erroring mapDataToProps; which sits
// outside of pagesHoc rendering.
//
// It's very important to use a unique key on this element so that React
// doesn't think that it can reuse an erroring ErrorBoundary.
// This would leave the stale error on the page despite users' attempts to
// navigate away
const BoundaryRoute = ({ renderError = Feature, ...props }) => (
  <RavenContext.Consumer>
    {raven => (
      <ErrorBoundary
        key={props.path || 'default'}
        renderError={renderError}
        raven={raven}
      >
        <Route {...props} />
      </ErrorBoundary>
    )}
  </RavenContext.Consumer>
)

Feature.propTypes = {
  error: PropTypes.any,
  info: PropTypes.any,
}

BoundaryRoute.propTypes = {
  renderError: PropTypes.func,
  path: PropTypes.string,
}

export default BoundaryRoute
